import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { Tooltip } from "@paylixecommerce/shared/components";
import moment from "moment";
import img from "./img.png";
import img1 from "./img_1.png";
import img2 from "./img_2.png";
import img3 from "./img_3.png";
import img4 from "./img_4.png";
import img5 from "./img_5.png";
import img6 from "./img_6.png";
import img7 from "./img_7.png";
import img8 from "./img_8.png";
import img9 from "./img_9.png";
import img10 from "./img_10.png";

import "../index.scss";

export const ArrowRightIcon = () => {
	return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M4.16675 10H15.8334" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M10.8333 15L15.8333 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M10.8333 5L15.8333 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
}


const Upgrade = ({ showUpgradeAlert, setShowUpgradeAlert }) => {

	const { pathname } = useLocation();
	const { profile } = useSelector(({ auth }) => auth);
	const bannerHeight = useSelector(({ nav }) => nav.bannerHeight);
	const hasSubscription = profile && profile.subscription && profile.subscription.id

	let ending;
	let image;
	let page;

	if(pathname === "/") {
		let items = [{
			ending: "to unlock All Features.",
			image: img
		}, {
			ending: "to save up to 4% in Fees.",
			image: img1
		}, {
			ending: "to increase your Cloud Size Limit.",
			image: img8
		}];

		let item = items[Math.floor(Math.random()*items.length)];

		ending = item.ending;
		image = item.image;
		page = 'main';

	} else if (pathname.includes("/payouts") || pathname.includes("/balances") || pathname.includes("/invoices")) {
		ending = "to save up to 4% in fees.";
		image = img1;
		page = 'invoice'
	} else if (pathname.includes("/themes") || pathname.includes("/pages") || pathname.includes("/navigation")) {
		ending = "to unlock Indexing, SEO, Link Preview Metadata.";
		image = img2;
		page = 'theme'
	} else if (pathname.includes("/feedback")) {
		ending = "to Appeal Feedback.";
		image = img3;
		page = 'feedback'
	} else if (pathname.includes("/settings/create/shop")) {
		ending = "to create up to 100 Stores.";
		image = img4;
		page = 'store'
	} else if (pathname.includes("/settings/shop/managers")) {
		ending = "to add up to 25 Managers per Store.";
		image = img5;
		page = 'manager'
	} else if (pathname.includes("/settings/security")) {
		ending = "to unlock account Security Logs.";
		image = img6;
		page = 'logs'
	} else if (pathname.includes("/settings/shop/fraud")) {
		ending = "to improve Fraud Detection.";
		image = img7;
		page = 'fraud'
	} else if (pathname.includes("/domains") || pathname.includes("/emails")) {
		ending = "to connect a Custom Domain.";
		image = img9;
		page = 'domain'
	}

	if(document && document.referrer && document.referrer.includes("help.paylix.gg")) {
		ending = "for Faster Support.";
		image = img10;
		page = 'support'
	}

	const onClose = () => {
		let now = moment().unix().toString();
		window.localStorage.setItem(`skip_upgrade_alert_${page}`, now);
		setShowUpgradeAlert(false);
	}

	useEffect(() => {

		if(page && !hasSubscription) {
			let now = moment();
			let inState = window.localStorage.getItem(`skip_upgrade_alert_${page}`)

			if(inState) {
				inState = moment.unix(+inState);
				let diff = Math.ceil(moment.duration(now.diff(inState)).asHours());

				if(diff > 24) {
					window.localStorage.removeItem(`skip_upgrade_alert_${page}`);
					setShowUpgradeAlert(true);
				} else {
					setShowUpgradeAlert(false);
				}
			} else {
				setShowUpgradeAlert(true);
			}
		} else {
			setShowUpgradeAlert(false);
		}

	}, [pathname, bannerHeight, page, hasSubscription]);

	if(showUpgradeAlert && ending && !hasSubscription) {
		return <div className="status-alert upgrade">
			<Link to="/plan-n-pricing">

				<div className="upgrade-container">
					<div className="upgrade-image">
						<img src={image} alt="" />
					</div>
					<div className="upgrade-header">
						Upgrade your <span style={{ textDecoration: "underline" }}>subscription</span> {ending} <span className="ml-1"><ArrowRightIcon /></span>
					</div>
				</div>

			</Link>

			<span onClick={onClose} data-tooltip-id="close-upgrade">
				<i className="upgrade-close-icon fa fa-times" />
			</span>
			<Tooltip name="close-upgrade" noArrow tooltipText="Dismiss this feature for 24h" isOutside />
		</div>
	} else {
		return null
	}
}


export default Upgrade;
